import React from 'react';
import {connect} from 'react-redux';
import {PlayerExposureSummary} from 'components/organisms/used-players-list/components/player-exposure-summary';

class PlayerExposureSummaryComponent extends PlayerExposureSummary {
    getPlayerDependOnLineupRole(playerId, lineupRole) {
        const players = this.props.players.all();

        for (let player of players) {
            if (player.getId() !== playerId) {
                continue;
            }

            if (player.getIsCaptain() && 'CPT' === lineupRole) {
                return {...player};
            }

            if (!player.getIsCaptain() && 'CPT' !== lineupRole) {
                return {...player};
            }
        }

        return null;
    }
}

function mapStatesToProps(state) {
    const {
        usedPlayers: {players, filters},
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;

    return {
        players,
        filterLineupsByPlayer,
        lineups,
        filters,
    };
}

export default connect(mapStatesToProps)(PlayerExposureSummaryComponent);
